// ======================================================================
// File Name       : ServiceGroupSuperUserEditList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Table, Form } from 'react-bootstrap';
import { connect } from 'react-redux';

class ServiceGroupSuperUserEditList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(this.props.editingServiceGroupSuperUser === nextProps.editingServiceGroupSuperUser);
  }

  render() {
    const { editingServiceGroupSuperUser } = this.props;
    const editingServiceGroup = Object.keys(editingServiceGroupSuperUser).sort((a, b) => {
      if (editingServiceGroupSuperUser[a].addNew && !editingServiceGroupSuperUser[b].addNew) {
        return -1;
      } if (!editingServiceGroupSuperUser[a].addNew && editingServiceGroupSuperUser[b].addNew) {
        return 1;
      }
      if (editingServiceGroupSuperUser[a].index < editingServiceGroupSuperUser[b].index) {
        return -1;
      } if (editingServiceGroupSuperUser[a].index > editingServiceGroupSuperUser[b].index) {
        return 1;
      }
      return 0;
    });

    return (
      <div>
        <Form.Group className="form-info margin-top-50" id="scroll-table-superuser">
          <Col as={Form.Label} sm={7} className="margin-top-15 padding-clear">
            所属管理ユーザー
          </Col>
          <Col sm={5} className="text-right padding-clear">
            <Button variant="default" onClick={this.props.handleRemoveAll}>ユーザ一一括削除</Button>
          </Col>
          <Col sm={12} className="padding-clear">
            <Table striped hover className="margin-top-7 margin-bottom-0">
              <thead>
                <tr>
                  <th>管理ユーザー名</th>
                  <th>ログインID</th>
                  <th className="col-md-1">操作</th>
                </tr>
              </thead>
              <tbody>
                {editingServiceGroup.map((userSecernId, index) => {
                  const data = editingServiceGroupSuperUser[userSecernId]
                    ? editingServiceGroupSuperUser[userSecernId]
                    : {};
                  return (
                    <tr key={index} className={data.addNew ? 'background_new_record' : ''}>
                      <td>{data.superuserName}</td>
                      <td>{data.loginId}</td>
                      <td className="text-center">
                        <i
                          role="button"
                          className="bi bi-trash"
                          onClick={this.props.handleRemoveUser.bind(null, userSecernId)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Form.Group>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authority } = state;
  return { group, authority: authority.authorityInfo };
};
export default connect(mapStateToProps)(ServiceGroupSuperUserEditList);
